<template>
  <div>
    <!-- Auth-blocked with static preview -->
    <template v-if="showLoginOverlay && staticComponent">
      <div class="auth-overlay-wrap">
        <!-- Blurred static content -->
        <div class="auth-overlay-blur">
          <component :is="staticComponent" v-bind="propsPropegation" />
        </div>
        <!-- Login card on top -->
        <div class="auth-overlay-login">
          <Login :has-static="true" />
        </div>
      </div>
    </template>

    <!-- Auth-blocked, no static: plain login -->
    <Login v-else-if="showLoginOverlay" />

    <!-- Authenticated: normal render -->
    <component v-else :is="componentToRender" v-bind="propsPropegation" />
  </div>
</template>

<script>
import Login from '@/views/Login.vue'

export default {
  components: { Login },
  props: {
    component: { type: [Object, Function], required: true },
    authRequired: { type: Boolean, default: false },
    staticComponent: { type: [Object, Function], default: null },
  },
  computed: {
    isLoggedIn() {
      return this.$store.state.auth.isLoggedIn
    },
    showLoginOverlay() {
      return this.authRequired && !this.isLoggedIn
    },
    shouldLockScroll() {
      return this.showLoginOverlay && !!this.staticComponent
    },
    componentToRender() {
      return this.component
    },
    propsPropegation() {
      return { ...this.$route.params }
    },
  },
  watch: {
    shouldLockScroll: {
      immediate: true,
      handler(val) {
        document.body.style.overflow = val ? '' : ''
      },
    },
  },
  activated() {
    if (this.shouldLockScroll) document.body.style.overflow = ''
  },
  deactivated() {
    document.body.style.overflow = ''
  },
  beforeDestroy() {
    document.body.style.overflow = ''
  },
}
</script>

<style>
.auth-overlay-login .card {
  border: 1px solid #1a73e8 !important;
}
</style>

<style scoped>
.auth-overlay-wrap {
  position: relative;
  pointer-events: none;
  user-select: none;
}

.auth-overlay-blur {
  filter: blur(4px);
  -webkit-filter: blur(4px);
}

.auth-overlay-login {
  position: absolute;
  top: 1rem;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  pointer-events: all;
  z-index: 2;
}
</style>
